<template>
  <div class="settings">
    <rp-profile-form
      @submit="submit"
      :genders="genderOption"
      :locales="locales"
      v-model="form"
      :role="showDob"/>
    <terms/>
    <rp-overlay :active="active">
      <rp-alert
        icon="done"
        :message="successMessage"
        :onClick="successFunction"
      >
      </rp-alert>
    </rp-overlay>
  </div>
</template>

<script>
import {updateProfile} from 'raypro_ui/src/api/users'
import {getLocales} from 'raypro_ui/src/api/locales'
import {mapGetters, mapMutations} from 'vuex'

import ProfileForm from 'raypro_ui/src/components/ui/forms/UserSettings'

import Terms from '@/components/Terms'

import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'
import page from '@/mixins/page'

export default {
  components: {
    'rp-profile-form': ProfileForm,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    Terms,
  },

  mixins: [page],

  data() {
    return {
      form: {},
      genderOption: [
        {'label': 'Male', 'value': 'M'},
        {'label': 'Female', 'value': 'F'},
        {'label': 'Prefer not to say', 'value': 'O'}
      ],
      locales: [],
      active: false,
      successMessage: 'User updated successfully!',
      title: 'General Settings'
    }
  },

  computed: {
    ...mapGetters([
      'authUser'
    ]),

    showDob() {
      if(this.$store.getters.authUser) {
        const roles = this.$store.getters.authUser.roles


        if(roles.indexOf('surgeon', 'nurses')) {
          return false
        }
        return true
      }
      return false
    },

    payloadProfile() {
      return {
        userUuid: this.authUser.id,
        data: {
          profile: {
            'first_name': this.form.first_name,
            'last_name': this.form.last_name,
            dob: this.form.dob,
            gender: this.form.gender,
            locale: this.form.locale
          }
        }
      }
    },
    payloadUser() {
      return {user: {email: this.form.email}}
    }
  },
  created() {
    this.form = {
      email: this.authUser.email,
      'first_name': this.authUser.profile.first_name,
      'last_name': this.authUser.profile.last_name,
      gender: this.authUser.profile.gender,
      dob: this.authUser.profile.dob,
      locale: this.authUser.profile.locale
    }
  },
  mounted() {
    getLocales().then(({data}) => {
      this.locales = data
    })
  },
  methods: {
    ...mapMutations(['SET_PROFILE']),

    successFunction() {
      this.active = false
    },

    submit() {
      updateProfile(this.payloadProfile).then(({data}) => {
        this.$store.commit('SET_PROFILE', data)
        this.active = true
        // updateUser(this.authUser.id, this.payloadUser).then(({data}) => {
        //   this.$store.commit('SET_USER', data)
        //   this.active = true
        // })
      })
    }
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/General.vue